
export const headerGif = 'https://minisomx.vtexassets.com/arquivos/temporal-topbar-mobile.gif';
export const headerGifDesktop='https://minisomx.vtexassets.com/arquivos/temporal-topbar-desktop.gif';

export const logoHeaderMinisoMobile = 'https://minisomx.vtexassets.com/assets/vtex.file-manager-graphql/images/81aed788-6a2c-45a9-b4ca-cc5c47042a1b___62e916c602d6b08f83a7faecd272e9e5.png';

export const logoRecogeEnTienda= 'https://minisomx.vtexassets.com/assets/vtex.file-manager-graphql/images/ad9136f5-91ed-4a15-961d-2b12850ebaeb___9dfe43a27b359da82c2cc7dfe292035d.webp';

export const logoHeaderMinisoDesktop = 'https://minisomx.vtexassets.com/assets/vtex.file-manager-graphql/images/14847a3f-b8b7-4885-a3cc-a0dbebcbcaa5___078c2a3ff77623a35f0b701693871619.webp';

export const logoVtexWhite = 'https://minisomx.vtexassets.com/arquivos/vtex-white.png';

export const logoCandadoWhite = 'https://minisomx.vtexassets.com/arquivos/ico_candado-01.png';

export const logoMercadoLibreWhite = 'https://minisomx.vtexassets.com/arquivos/ico_mercado_pago_bn-01.png';

export const logoPaypalWhite = 'https://minisomx.vtexassets.com/arquivos/logo_paypal_footer.png';

export const logoVisaWhite = 'https://minisomx.vtexassets.com/arquivos/ico_visa_bn-01.png';

export const logoMasterCardWhite= 'https://minisomx.vtexassets.com/arquivos/ico_mastercard_bn-01.png';

export const logoAmexWhite = 'https://minisomx.vtexassets.com/arquivos/ico_amex-01.png';

export const logoKueskiWhite = 'https://minisomx.vtexassets.com/arquivos/kuskipay_logo_footer_blanco.png';

export const logoFaceMiniso= 'https://minisomx.vteximg.com.br/arquivos/facebook-email.png';

export const logoInstaMiniso='https://minisomx.vteximg.com.br/arquivos/instagram-email.png';

export const logoMinisoConfirmEmail = 'https://minisomx.vteximg.com.br/arquivos/nuevo-logo-miniso.png';

export const img1CarruselDesktop = 'https://minisomx.vtexassets.com/assets/vtex.file-manager-graphql/images/7fa21e32-8fe0-431d-bd57-116a7df1cfa5___855817868699d47c98afbc2e7f965213.webp';

export const img1CarruselMobile = 'https://minisomx.vtexassets.com/assets/vtex.file-manager-graphql/images/20e66cd3-d237-47f0-9be2-e4c3726c3add___ba5067db8ef80c2099ced2d34b65a179.webp';

export const imgWelcomeMinisoLover = 'https://minisomx.vteximg.com.br/arquivos/header_bienvenida_MinisoLove_800x350px.jpg';

export const pinguinoAzulRegistro ='https://minisoqa.vtexassets.com/arquivos/form-header.png';